// @flow
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import type { CinemaGraphProps } from '../../types'
import styles from './cinemaGraph.css'

class CinemaGraph extends PureComponent {
  props: CinemaGraphProps
  video: Object

  componentDidUpdate (): void {
    const { aVideoIsPlaying } = this.props
    if (aVideoIsPlaying) {
      this.video.pause()
    } else {
      if (this.video.paused) {
        this.video.play()
      }
    }
  }

  render () {
    const { poster, srcset, aVideoIsPlaying } = this.props
    return (
      <div className={styles.cinemaGraph}>
        <video ref={(c) => { this.video = c }} className={styles.cinemaGraphVideo} preload autoPlay={!aVideoIsPlaying} loop playsInline muted poster={poster}>
          {typeof srcset !== 'undefined' && srcset.map((source) => (
            <source key={source.type} src={source.src} type={source.type} />
          ))}
        </video>
      </div>
    )
  }
}

export default connect((state) => {
  return {
    aVideoIsPlaying: state.video.isPlaying
  }
})(CinemaGraph)



// WEBPACK FOOTER //
// ./src/shared/components/CinemaGraph/cinemaGraph.js